import { render, staticRenderFns } from "./RedmineIssueCreatePage.vue?vue&type=template&id=3c9926dc&scoped=true"
import script from "./RedmineIssueCreatePage.vue?vue&type=script&lang=js"
export * from "./RedmineIssueCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9926dc",
  null
  
)

export default component.exports